import { InstructionList } from '@/components';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { FC } from 'react';
import { Simplify } from '../../../../../prismicio-types';

import styles from './termsInstrictionInner.module.scss';

const titleComponents: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

type Props = {
  slice: Content.TermsInstrictionSlice;
};

export const TermsInstrictionInner: FC<Props> = ({ slice }) => {
  switch (slice.variation) {
    case 'default':
      return (
        <InstructionList
          list={slice.primary.instruction}
          variation={slice.variation}
        />
      );
    case 'numbered':
      return (
        <InstructionList
          list={
            slice.primary
              .instruction as Simplify<Content.TermsInstrictionSliceDefaultPrimaryInstructionItem>[]
          }
          variation={slice.variation}
        />
      );
    case 'numberedSmallWithTitle':
      return (
        <>
          <PrismicRichText
            field={slice.primary.title}
            components={titleComponents}
          />
          <InstructionList
            list={
              slice.primary
                .instruction as Simplify<Content.TermsInstrictionSliceDefaultPrimaryInstructionItem>[]
            }
            variation={slice.variation}
          />
        </>
      );
    case 'unnumberedSmallWithTitle':
      return (
        <>
          <PrismicRichText
            field={slice.primary.title}
            components={titleComponents}
          />
          <InstructionList
            list={
              slice.primary
                .instruction as Simplify<Content.TermsInstrictionSliceDefaultPrimaryInstructionItem>[]
            }
            variation={slice.variation}
          />
        </>
      );
    case 'defaultWithoutTitle':
      return (
        <InstructionList
          list={
            slice.primary
              .instruction as Simplify<Content.TermsInstrictionSliceDefaultPrimaryInstructionItem>[]
          }
          variation={slice.variation}
        />
      );
    default:
      return <></>;
  }
};
